import React, {Component} from 'react'
import {withStyles} from '@material-ui/core/styles'
import { LinearProgress, Tab, Tabs } from '@material-ui/core'
import {bindActionCreators} from 'redux'
import {withRouter} from 'react-router-dom'
import {connect} from 'react-redux'
import ReduxMedical from "../../../../store/actionreducers/adminMedical/medical"
import {FusePageSimple} from '../../../../@fuse/index'
import UecareListHeader from "../../../../components/header/UecareListHeader"
import ReduxGlobal from "../../../../store/actionreducers/globalView"
import ReduxCity from "../../../../store/actionreducers/city"
import UecareAlertDialog from "../../../../components/UecareAlertDialog"
import InstitutionMedicalList from "./InstitutionMedicalList"


const tabValueToRoleIdMapping = {
    1: 6,
    2: 7,
    3: 8,
    4: 9,
    5: 10,
    6: 1,
    7: 4,
}

class InstitutionMedicalApp extends Component {

    state = {
        tabValue: 0,
    };

    handleChangeTab = (event, tabValue) => {
        this.setState({tabValue})
    };

    async componentDidMount() {
        await this._reload()
    }

    async _reload() {
        this.setState({ isLoading: true })
        await this.props.getMedicals()
        this.setState({ isLoading: false })
    }

    render() {
        const {classes, medicals} = this.props
        const {tabValue} = this.state

        const filteredMedicals = medicals.filter(medical => {
                if(tabValue === 0)
                    return medical
                else
                    return medical.user.fk_role_id === tabValueToRoleIdMapping[tabValue]
            }
        )

        return (
            <React.Fragment>
                <FusePageSimple
                    className={classes.root}
                    classes={{
                        root: classes.layoutRoot,
                        contentCardWrapper: classes.layoutContentCardWrapper,
                        leftSidebar: classes.layoutLeftSidebar
                    }}
                    header={
                        <UecareListHeader title='本院醫療顧問列表' icon='local_hospital' reload={() => this._reload()} />
                    }
                    contentToolbar={
                        <div style={{ width: '100%' }}>
                            <LinearProgress
                                color="secondary"
                                style={{ visibility: this.state.isLoading ? 'visible' : 'hidden' }}
                            />
                            <Tabs
                                value={tabValue}
                                onChange={this.handleChangeTab}
                                indicatorColor="secondary"
                                textColor="secondary"
                                scrollable
                                scrollButtons="auto"
                                classes={{ root: 'w-full h-40' }}>
                                <Tab className="h-40 normal-case font-extrabold" label="全部" />
                                <Tab className="h-40 normal-case font-extrabold" label="急診醫師" />
                                <Tab className="h-40 normal-case font-extrabold" label="專科醫師" />
                                <Tab className="h-40 normal-case font-extrabold" label="顧問醫師" />
                                <Tab className="h-40 normal-case font-extrabold" label="藥師" />
                                <Tab className="h-40 normal-case font-extrabold" label="護理師" />
                                <Tab className="h-40 normal-case font-extrabold" label="管理者" />
                                <Tab className="h-40 normal-case font-extrabold" label="專科護理師" />
                            </Tabs>
                        </div>
                    }
                    content={
                        <div>
                            <div className="p-16">
                                <InstitutionMedicalList medicals={filteredMedicals}/>
                            </div>
                            <UecareAlertDialog/>
                        </div>
                    }

                    sidebarInner
                    onRef={instance => {
                        this.pageLayout = instance
                    }}
                />

                <UecareAlertDialog/>
            </React.Fragment>
        )
    }
}

const styles = theme => ({
    root: {},
    layoutContentCardWrapper: {
        padding: 16,
    },
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getMedicals: ReduxMedical.ActionCreator.getMedicals,
        openDataDialog: ReduxGlobal.ActionCreator.openDataDialog,
        getCities: ReduxCity.ActionCreator.getCities,
    }, dispatch);
}

function mapStateToProps({auth, adminMedicalList: {medicals}}) {
    return {
        user: auth.user,
        medicals
    }
}
export default withStyles(styles, {withTheme: true})(withRouter(connect(mapStateToProps, mapDispatchToProps)(InstitutionMedicalApp)));



// WEBPACK FOOTER //
// ./src/main/content/adminMedical/institutionMedical/InstitutionMedicalApp.js